import {isWechatMiniProgram} from './device'

// 沉浸承载页（小程序 pages/m/imm）以 mp=imm 标识
const query = new URLSearchParams(window.location.search)
const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export const mpImmersive = query.get('mp') === 'imm' && (isWechatMiniProgram() || isLocalDev)

const startHistoryLength = window.history.length
export const mpCanGoBack = () => window.history.length > startHistoryLength



// WEBPACK FOOTER //
// ./src/utils/mp.js